import React, { useEffect, useState } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import PinDropIcon from '@material-ui/icons/PinDrop';

import { currentLocationIsAvailable } from './../location';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    height: '100vh',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  dropContainer: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '10px',
    marginRight: '10px',
  },
}));

const OutOfRange = () => {
  const classes = useStyles();

  const [locationIsAvailable, setLocationIsAvailable] = useState(null);
  useEffect(() => {
    currentLocationIsAvailable().then((isAvailable) => setLocationIsAvailable(isAvailable));
  }, [setLocationIsAvailable]);

  return (
    <div className={classes.root}>
      <Box className={classes.dropContainer}>
        <PinDropIcon style={{ color: '#FF0000', fontSize: '300px' }} />
      </Box>
      <Box className={classes.textContainer}>
        <Typography align="center" variant="h2">
          Out of Reach
        </Typography>
        <Typography align="center" variant="subtitle1">
          {locationIsAvailable === false ? (
            <>
              To be able to see the list of residents of this building we need to check your location.
              <br />
              <a href="https://support.google.com/chrome/answer/142065?hl=en">See how to enable it</a>
            </>
          ) : (
            "Your current location doesn't match with the location of the building."
          )}
        </Typography>
      </Box>
    </div>
  );
};

export default OutOfRange;
